module.exports = require("date-fns/is_valid");


//////////////////
// WEBPACK FOOTER
// external "date-fns/is_valid"
// module id = 42
// module chunks = 0